import cleanDeep from 'clean-deep';
import React from 'react';
import { connect } from 'react-redux';

import Select from 'react-select'
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import { validateInteger } from '../../common/validation/Validators';
import OccupationalLeaveRuleApplyTo from './OccupationalLeaveRuleApplyTo';
import OccupationalLeaveRuleEntitlement from "./OccupationalLeaveRuleEntitlement";

const OccupationalLeaveRule = ({
    leaveRule,
    leaveTypeOptions,
    updateSetting,
    disabled,
    rowIndex,
    departmentOptions,
    filteredDepartmentOptions
}) => {
    return (
        <div className="col-lg-12 form-container pt-5 pb-5"
        style={{
           borderBottom: "solid 1px #666",
        }}>
            <div className="col-sm-4 pl-0">
                <div className="form-material">
                    <Select
                        options={leaveTypeOptions}
                        name="department"
                        value={leaveTypeOptions?.find(option => option.value == leaveRule.type)}
                        placeholder="Choose one..."
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateSetting('type', selected.value)
                        }}
                    />
                    <label>Absence Type</label>
                </div>
            </div>
            <div className="col-sm-4 pl-0">
                <div className="form-material">
                    <input
                        className='form-control form-input'
                        name="name"
                        value={leaveRule?.name}
                        defaultValue={leaveRule?.name}
                        onChange={(e) => {
                            updateSetting(e.target.name, (e.target.value))
                        }}
                        disabled={disabled}

                    />
                    <label>Rule Name (internal use)</label>
                </div>
            </div>

            <div className="col-sm-12 pl-0 pr-0 mt-10">
                <label>Apply this rule</label>
                {
                    leaveRule?.applyTo?.map((applyTo, index) => {
                        return (
                            <OccupationalLeaveRuleApplyTo
                                key={index}
                                partIndex={index}
                                lastPart={leaveRule?.applyTo.length - 1 === index}
                                id={leaveRule.id}
                                applyTo={applyTo}
                            />
                        );
                    })
                }
            </div>

            <div className="col-sm-12 pl-0 pr-0 mt-10">
                <label>Apply After</label>

                <div className="col-sm-12 pl-0 pr-0">
                    <div
                        className="input-group"
                        style={{
                            zIndex: 0,
                            maxWidth: "125px",
                        }}
                    >
                        <input
                            type="number"
                            className="form-control"
                            style={{ height: "39px", minWidth: "30px", maxWidth: "30px", paddingLeft: 10 }}
                            value={leaveRule.waitingDays}
                            onChange={(e) => {
                                updateSetting("waitingDays", validateInteger(e.target.value));
                            }}
                        />
                        <span
                            className={`input-group-addon `}
                            style={{
                                padding: "0 5px",
                                border: "none",
                                lineHeight: "38px",
                                width: "29px",
                                textAlign: "center",
                                userSelect: "none",
                            }}
                        >
                            <span style={{ width: "100%", userSelect: "none" }}>waiting days</span>
                        </span>
                    </div>
                </div>

                <div className="col-sm-12 pl-0 pr-0">
                    <div
                        className="input-group"
                        style={{
                            zIndex: 0,
                            maxWidth: "125px",
                        }}
                    >
                        <span
                            className={`input-group-addon `}
                            style={{
                                padding: "0 5px",
                                border: "none",
                                lineHeight: "38px",
                                width: "29px",
                                textAlign: "center",
                                userSelect: "none",
                            }}
                        >
                            <span style={{ width: "100%", userSelect: "none" }}>Consider {leaveTypeOptions?.find(option => option.value == leaveRule.type)?.label} entries less than</span>
                        </span>
                        <input
                            type="number"
                            className="form-control"
                            style={{ height: "39px", minWidth: "50px", maxWidth: "50px", paddingLeft: 10 }}
                            value={leaveRule.gapDays}
                            onChange={(e) => {
                                updateSetting("gapDays", validateInteger(e.target.value));
                            }}
                        />
                        <span
                            className={`input-group-addon `}
                            style={{
                                padding: "0 5px",
                                border: "none",
                                lineHeight: "38px",
                                width: "29px",
                                textAlign: "center",
                                userSelect: "none",
                            }}
                        >
                            <span style={{ width: "100%", userSelect: "none" }}>days apart to be part of one application.</span>
                        </span>
                    </div>
                </div>
            </div>



            <div className="col-sm-12 pl-0 pr-0 mt-10">
                <label>And entitle them to</label>
                {
                    leaveRule?.entitlements?.map((entitlement, index) => {
                        return (
                            <OccupationalLeaveRuleEntitlement
                                key={index}
                                partIndex={index}
                                lastPart={leaveRule?.entitlements.length - 1 === index}
                                id={leaveRule.id}
                                entitlement={entitlement}
                            />
                        );
                    })
                }
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const departmentOptions = state?.company?.settings?.departments?.map(dep => ({
        value: dep.id,
        label: dep.name,
    }))

    const usedDepartments = cleanDeep(state?.leave?.leaveSettings?.sickNotificationPeriods?.map(period => period.department))

    const leaveTypeOptions = state?.leave?.leaveTypes?.map(type => ({
        value: type.id,
        label: type.name,
    }))

    return {
        departmentOptions,
        leaveTypeOptions,
        filteredDepartmentOptions: departmentOptions?.filter((department) => { return usedDepartments?.indexOf(department.value) == -1; }),
        disabled:( state?.permissions?.my?.permissions?.settings == 'Read') || (state?.company?.settings?.status == 'Archived')
    }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    updateSetting: (field, value) => dispatch(ACTIONS.updateLeaveRule({
        field,
        value,
        id: ownProps?.leaveRule?.id
    }))
});

export default connect(mapStateToProps, mapDispatchToProps)(OccupationalLeaveRule);